import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Login.css';
import apiClient from '../../api';
import { baseurl } from '../../api';


  const Login = ({ setIsAuthenticated }) => {
    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
  
    const handleLogin = async (e) => {
      e.preventDefault();
      setError('');
      setIsLoading(true);

      const loginPayload = {
          email: email.trim(),
          password: password
      };

      try {
          const response = await apiClient.post('accounts/login/internal/', loginPayload);
          const data = response.data;

          if (data.access && data.refresh) {
              localStorage.setItem('accessToken', data.access);
              localStorage.setItem('refreshToken', data.refresh);
              // No need to store 'bearer' separately as apiClient handles this
              setIsAuthenticated(true);
              navigate('/dashboard');
          } else {
              setError('Invalid credentials');
          }
      } catch (error) {
          if (error.response?.data?.message) {
              setError(error.response.data.message);
          } else if (error.response?.data?.detail) {
              setError(error.response.data.detail);
          } else {
              setError('Login failed. Please try again.');
          }
      } finally {
          setIsLoading(false);
      }
    };

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    return (
      <div className="registration-whole-container">
        <div className="sub-container-reg">
          <div className="reg-navbar">
            <div className="logo-container">
              <img
                src="assets/reg-nav-logo.png"
                alt="logo"
                className="reg-navbar-logo"
              />
            </div>
  
            <div className="country-nav">
              <img
                src="assets/country2.png"
                alt="country flag"
                className="country-image"
              />
              <select
                id="countrySelect"
                className="countries-name common-text fts-13 ftw-4 black"
              >
                <option>English</option>
                <option>Arabic</option>
                <option>Tamil</option>
              </select>
            </div>
          </div>
        </div>
        
        <div className="login-form-container">
          <div className="login-form-sub-container">
            <span className="black common-text ftw-6 welcome-back">Welcome Back</span>
            <p className="common-text fts-18 dk-gray">Login into your account</p>
            
            {error && (
              <p className="error-text red" role="alert">
                {error}
              </p>
            )}
  
            <form onSubmit={handleLogin} autoComplete="off">
              <div className='login-input d-flex ai-center w-100 jc-sb login-password fts-14 common-text bg-white mt-30'>
                <input
                  className="w-100 fts-17 h-100 bg-trans"
                  type="email"
                  placeholder="Email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  disabled={isLoading}
                  required
                   autoComplete="off"
                />
              </div>

              <div className='login-input d-flex ai-center w-100 jc-sb login-password fts-14 common-text bg-white'>
                <input
                  type={showPassword ? "text" : "password"}
                  className="h-100 w-100 fts-17"
                  placeholder="Password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  disabled={isLoading}
                  required
                   autoComplete="off"
                />
                {showPassword ? (
                  // Open Eye Icon (Password is visible)
                  <svg 
                    width="20" 
                    height="20" 
                    viewBox="0 0 576 512" 
                    fill="rgb(160, 156, 156)" 
                    xmlns="http://www.w3.org/2000/svg"
                    onClick={togglePasswordVisibility}
                    style={{ cursor: 'pointer' }}
                  >
                    <path d="M572.52 241.4C518.29 135.13 407.65 64 288 64S57.71 135.13 3.48 241.4a48.6 48.6 0 0 0 0 29.2C57.71 376.87 168.35 448 288 448s230.29-71.13 284.52-177.4a48.6 48.6 0 0 0 0-29.2zM288 400c-79.4 0-160.54-46.55-207.62-128C127.46 190.55 208.6 144 288 144s160.54 46.55 207.62 128C448.54 353.45 367.4 400 288 400zm0-240a112 112 0 1 0 112 112A112 112 0 0 0 288 160z"/>
                  </svg>
                ) : (
                  // Closed Eye Icon (Password is hidden)
                  <svg 
                    width="20" 
                    height="20" 
                    viewBox="0 0 640 512" 
                    fill="rgb(160, 156, 156)" 
                    xmlns="http://www.w3.org/2000/svg"
                    onClick={togglePasswordVisibility}
                    style={{ cursor: 'pointer' }}>
                    <path d="M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L525.6 386.7c39.6-40.6 66.4-86.1 79.9-118.4c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C465.5 68.8 400.8 32 320 32c-68.2 0-125 26.3-169.3 60.8L38.8 5.1zM223.1 149.5C248.6 126.2 282.7 112 320 112c79.5 0 144 64.5 144 144c0 24.9-6.3 48.3-17.4 68.7L408 294.5c8.4-19.3 10.6-41.4 4.8-63.3c-11.1-41.5-47.8-69.4-88.6-71.1c-5.8-.2-9.2 6.1-7.4 11.7c2.1 6.4 3.3 13.2 3.3 20.3c0 10.2-2.4 19.8-6.6 28.3l-90.3-70.8zM373 389.9c-16.4 6.5-34.3 10.1-53 10.1c-79.5 0-144-64.5-144-144c0-6.9 .5-13.6 1.4-20.2L83.1 161.5C60.3 191.2 44 220.8 34.5 243.7c-3.3 7.9-3.3 16.7 0 24.6c14.9 35.7 46.2 87.7 93 131.1C174.5 443.2 239.2 480 320 480c47.8 0 89.9-12.9 126.2-32.5L373 389.9z"/>
                  </svg>
                )}


              </div>
              
              <button
                type="submit"
                className="login-input common-text fts-18 ftw-4 white bg-dk-blue"
                disabled={isLoading}
              >
                {isLoading ? 'Logging in...' : 'Log in'}
              </button>
              <span 
                className="forgot-password"
                onClick={() => window.location.href = `${baseurl}reset-password-form/?source=internal`}
                style={{ cursor: 'pointer', color: 'gray', marginTop: '10px' }}
              >
                Forgot password ?
              </span>
            </form>
          </div>
        </div>
      </div>
    );
};
  
export default Login;